import { RouteView } from '@/layouts';

const cardTicketRouter = {
  path: '/cardticket',
  name: 'CardTicket',
  redirect: '/cardticket/list',
  component: RouteView,
  meta: {
    title: '卡券管理',
    icon: 'iconcoupons',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'CardTicketList',
      component: () => import('@/views/cardTicket/List'),
      meta: {
        title: '卡券列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'add',
      name: 'CardTicketAdd',
      component: () => import('@/views/cardTicket/Add'),
      meta: {
        title: '添加卡券',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'CardTicketEditor',
      component: () => import('@/views/cardTicket/Editor'),
      meta: {
        title: '编辑卡券',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'detail',
      name: 'CardTicketDetail',
      component: () => import('@/views/cardTicket/Detail'),
      meta: {
        title: '查看',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default cardTicketRouter;
